<template>
    <v-card outlined id="profile-menu" class="profile-menu mr-4 border-transparent">
        <div class="text-center font-weight-bold f-s-16 text-uppercase py-5">{{ $t('personalProfile')}}</div>
        <v-divider></v-divider>
        <div class="d-flex menu-data-wrapper">
            <profile-menu-skeleton v-if="loading"></profile-menu-skeleton>
            <div class="text-center">
                <div class="menu-avatar mb-2" v-if="!loading">
                    <v-avatar size="112">
                        <v-img :src="imageLogo"></v-img>
                        <div class="icon-wrapper" @click="editAvatar">
                            <v-icon class="text--main-yellow" absolute>camera_alt</v-icon>
                        </div>
                    </v-avatar>
                </div>
                <v-btn
                        v-if="userData.image"
                        text
                        class="text-capitalize"
                        @click="deleteAvatar"
                >
                    {{ $t('deleteAvatar') }}
                </v-btn>
            </div>
            <div v-if="!loading" class="pl-2">
                <div class="profile-name pt-0 pb-4">{{ fio }}</div>
                <div class="py-1">
                    <v-icon class="text--main-yellow">account_balance</v-icon>
                    <router-link :to="companyLinkPrefix + companyId">
                        <span class="f-s-14 text-underline-hover black--text">{{ companyName }}</span>
                    </router-link>
                </div>
                <div class="py-1">
                    <v-icon class="text--main-yellow">schedule</v-icon>
                    <span class="f-s-14">На Agrolink с {{ userData.date }}</span>
                </div>
                <div class="py-1">
                    <v-icon class="text--main-yellow">place</v-icon>
                    <span class="f-s-14">{{ location }}</span>
                </div>
            </div>
        </div>
        <v-divider></v-divider>
        <v-list nav class="menu-nav hidden-sm-and-down">
            <v-list-item-group class="text--main-yellow">
                <v-btn
                        class="button-hover body-2 font-weight-bold py-4 px-0 d-flex justify-start"
                        text
                        link
                        :to="{name: link.route}"
                        width="100%"
                        v-for="link in menuItems"
                        :key="link.text"
                >
                    <v-icon class="mx-4">{{ link.icon }}</v-icon>
                    {{ link.text }}
                </v-btn>
                <v-btn
                        class="body-2 font-weight-bold py-6 px-0 text--main-yellow"
                        color=""
                        text
                        link
                        to=""
                        width="100%"
                        @click="openSnack"
                        v-if="isLinkExist"
                >
                    <v-icon class="mr-4">exit_to_app</v-icon>
                    {{ $t('exit') }}
                </v-btn>
            </v-list-item-group>
        </v-list>
        <avatar-edit v-model="openAvatarEdit" :image="userData.image" @image-uploaded="imageUploaded"></avatar-edit>
        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
        >
            {{ $t('exit?') }}
            <div>
                <v-btn text class="text--main-yellow" @click="$emit('logout')">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
        <snack-general :snack-data="snackData"></snack-general>
    </v-card>
</template>

<script>

    import AppSnack from '../../../../general/mixins/AppSnack';
    import AvatarEdit from '../avatar-edit';
    import ProfileService from '../../../../app-front/services/api/ProfileService';
    import ProfileDataProvider from "../../../mixins/ProfileDataProvider";
    import ProfileMenuSkeleton from "../../../components/skeletons/ProfileMenuSkeleton";
    import SnackGeneral from '../../snacks/SnackGeneral';

    import './profile-menu.scss';

    export default {
        name: "Menu",
        components:{AvatarEdit, ProfileMenuSkeleton, SnackGeneral},
        mixins:[ProfileDataProvider, AppSnack],
        props: ['activeLink'],
        data() {
            return {
                isLoaded: false,
                links: [
                    { text: this.$t('mainInfo'), icon: 'home' , route: 'profilePersonal', name:'companyPage', forBuyer: true},
                    { text: this.$t('companyInfo'), icon: 'store' , route: 'companyPage', name:'profileHome', forBuyer: true},
                    { text: this.$t('commercialPolicy'), icon: 'mdi-file-document-box', route: 'commercialPolicy', name:'commercialPolicy', forBuyer: false},
                    { text: this.$t('myContracts'), icon: 'description', route: 'profileContracts', name:'profileContracts', forBuyer: false},
                    { text: this.$t('myBasket'), icon: 'shopping_bag', route: 'profileBasket', name:'profileBasket', forBuyer: true},
                    { text: this.$t('mySales'), icon: 'attach_money', route: 'profileSales', name:'profileSales', forBuyer: false},
                    { text: this.$t('productsManage'), icon: 'local_offer', route: 'profileProducts', name:'profileProducts', forBuyer: false},
                    { text: this.$t('addingProduct'), icon: 'add_circle', route: 'productAdd', name:'productAdd', forBuyer: false},
                    { text: this.$t('favorites'), icon: 'favorite_border', route: 'profileFavorites', name:'profileFavorites', forBuyer: true},
                ],
                loading: true,
                openAvatarEdit: false,
                companyLinkPrefix: '/companies/',
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                }
            }
        },
        computed:{
            currentRoute:{
                get() {
                    return this.activeLink
                },
                set(newRoute) {
                    // this.activeLink = newRoute;
                }
            },
            fio() {
                let fio = '';

                if(this.userData.firstName)
                    fio += this.userData.firstName;

                if(this.userData.lastName)
                    fio += ` ${this.userData.lastName}`;

                return fio;
            },
            location() {
                return this.userData.geo ? this.userData.geo.name : '';
            },
            imageLogo(){
                return  this.userData.image && this.userData.image.url ? this.userData.image.url : '/images/default-user.png' ;
            },
            companyName() {
                return this.companyInfo ? this.companyInfo.name : null;
            },
            companyId() {
                return this.companyInfo ? this.companyInfo.id : null;
            },
            companyInfo() {
                return this.userData.company;
            },
            userData() {
                return this.$store.getters.profileData;
            },
            menuItems() {
                const items = [];
                this.links.forEach(item => {
                    if(this.isSeller) {
                        items.push({text: item.text, icon: item.icon, route: item.route, name: item.name})
                    }
                    else {
                        if(item.forBuyer) {
                            items.push({text: item.text, icon: item.icon, route: item.route, name: item.name})
                        }
                    }
                });
                return items;
            }
        },
        methods:{
            deleteAvatar() {
                ProfileService.deleteAvatar({image: null})
                    .then(res => {
                        this.snackHandle(this.$t('avatarDeleted'), 'main--black', true);
                        const userData = this.userData;
                        userData.image.url = null;
                        this.setStateProfile(userData);
                    })
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true);
                        console.log(err.data);
                    });
            },
            editAvatar() {
                this.openAvatarEdit = !this.openAvatarEdit;
            },
            isLinkExist(link) {

                if(link.name === 'profileBasket' && !this.userData.isBuyer) { return false; }

                if(link.name === 'profileSales' && !this.userData.isSeller) { return false; }


                return true;
            },
            imageUploaded(url) {
                const userData = this.userData;
                userData.image.url = url;

                this.setStateProfile(userData);
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        },
        created() {
            if(this.isProfileEmpty()) {
                this.setProfileData();
            } else {
                this.loading = false;
            }

        }
    }
</script>

<style scoped>
    .menu-avatar {
        margin-right: 30px;
        margin-left: 19px;
    }

    .menu-avatar .icon-wrapper {
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        border:1px solid #F5B821;
        background: #fff;
        cursor: pointer;
        left: -8px;
        bottom: 3px;
    }

    .menu-data-wrapper {
        padding-bottom: 31px;
        padding-top: 21px;
    }

    .menu-header {
        padding: 20px 0 5px;
    }

    .menu-nav {
        padding-top: 21px;
    }

    .menu-nav-item-content {
        padding: 5px 0;
    }

    .profile-name {
        font-weight: 700;
        padding-bottom: 5px;
    }
</style>
